import Axios from 'axios';
import Apis from '../Apis';
import CustomerCleanerAction from '../Actions/CustomerCleanerAction';
import GeneralAction from '../Actions/GeneralAction';
import AlertAction from '../Actions/AlertActions';
import { getHeaders } from '../../utills';

class CustomerCleanerMiddleware {
  static getCustomerCleaner = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.search || userData?.next_page_url == undefined) {
            if (userData?.search && userData?.next_page_url) {
            } else {
              dispatch(CustomerCleanerAction.clearCustomerCleaner());
            }
          }
          let formdata = new FormData();
          if (userData?.Search) {
            formdata.append('name', userData?.Search);
          }
          if (userData?.Id) {
            formdata.append('category_id', userData?.Id);
          }

          const { data } = await Axios.post(
            Apis.getCustomerActiveJobs(userData?.next_page_url),
            formdata,
            { headers: getHeaders() },
          );
          if (data?.success) {
            dispatch(CustomerCleanerAction.getCustomerCleaner(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default CustomerCleanerMiddleware;
